import { render } from "./AjustesCadastrais.vue?vue&type=template&id=0fd06568&scoped=true"
import script from "./AjustesCadastrais.vue?vue&type=script&lang=js"
export * from "./AjustesCadastrais.vue?vue&type=script&lang=js"

import "./AjustesCadastrais.vue?vue&type=style&index=0&id=0fd06568&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd06568"]])

export default __exports__